import { InvalidCryptoError } from '#web-service-api/principal';
// The core fields (publicKey, sMemberByInvitationKey, ePrivateKeyByInvitationKey)
// alone prove initialization: some callers (e.g. invitation acceptance) don't have
// eInvitationPrivateKeyByMemberKey at all. It still must be unset for a member to
// need initialization — crypto init writes it and its compare-and-set guard requires
// it to be null — so a member whose only set crypto field is
// eInvitationPrivateKeyByMemberKey is invalid rather than initializable.
export const shouldInitializeMemberCrypto = (params) => {
    if (params.publicKey &&
        params.sMemberByInvitationKey &&
        params.ePrivateKeyByInvitationKey) {
        return false;
    }
    if (!params.publicKey &&
        !params.sMemberByInvitationKey &&
        !params.ePrivateKeyByInvitationKey &&
        !params.eInvitationPrivateKeyByMemberKey) {
        return true;
    }
    throw new InvalidCryptoError(`Member cannot have partial crypto, ${params.principalId}`);
};
